module.exports = __webpack_public_path__ + "img/pancakes.b35271f1.gif";